'use client';
import { Table as MuiTable, TableProps } from '@mui/material';

const Table = (props: TableProps & { animated?: boolean }) => {
  const { animated, ...rest } = props;

  return <MuiTable {...rest} />;
};

export default Table;
